import { ChatListPanelHeader } from "../chats/ChatListPanelHeader";
import { Divider } from "@mui/material";
import {
  FilterDataType,
  IUserInfo,
  USER_TYPE,
} from "@home-health-notify/domain";
import UserDirectoryListItem from "./UserDirectoryListItem";
import EmptyRecordView from "../common/EmptyRecordView";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "hhn-commons";
import UserDirectorySearch from "./UserDirectorySearch";
import styled from "@emotion/styled";
import { Virtuoso } from "react-virtuoso";
import { shouldForwardProp } from "../common/Common.style";
import {
  UserDirectorySearchWrapper,
  UserDirectoryTabItemWrapper,
} from "./UserDirectory.style";

interface UserDirectoryTabItemProps {
  chatID: string;
  currentUserTypes: USER_TYPE[];
  defaultSelectedUserTypes: USER_TYPE[];
  filterTooltipData: FilterDataType;
  setFilterTooltipData: Dispatch<SetStateAction<FilterDataType>>;
  filteredUserDirectory: IUserInfo[];
  setFilteredUserDirectory: Dispatch<SetStateAction<IUserInfo[]>>;
  testId: string;
}

type StyleBoxProps = {
  isLoading?: boolean;
};
export const ScrollListContainerStyle = styled(Virtuoso<IUserInfo>, {
  shouldForwardProp: prop =>
    shouldForwardProp<StyleBoxProps>(["isLoading"], prop),
})<StyleBoxProps>({
  overflowY: "auto",
  flexShrink: 1,
  display: "block",
  position: "relative",
  height: "calc(100% - 110px)",
});

const UserDirectoryTabItem = ({
  chatID,
  currentUserTypes,
  filterTooltipData,
  setFilterTooltipData,
  filteredUserDirectory,
  setFilteredUserDirectory,
  defaultSelectedUserTypes,
  testId,
}: UserDirectoryTabItemProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "userDirectory" });

  return (
    <UserDirectoryTabItemWrapper
      data-testid={`${testId}-user-directory-container`}
    >
      <Divider />
      <UserDirectorySearchWrapper>
        <UserDirectorySearch
          setFilteredUserDirectory={setFilteredUserDirectory}
          filterTooltipData={filterTooltipData}
          setFilterTooltipData={setFilterTooltipData}
          currentUserTypes={currentUserTypes}
          defaultSelectedUserTypes={defaultSelectedUserTypes}
        />
      </UserDirectorySearchWrapper>
      <Divider />
      <ChatListPanelHeader
        header={`${filteredUserDirectory.length} ${tNs("headerMembersTitle")}`}
      />
      <Divider />
      {filteredUserDirectory.length > 0 ? (
        <ScrollListContainerStyle
          data-testid="user-directory-test-id"
          totalCount={filteredUserDirectory.length}
          data={filteredUserDirectory}
          itemContent={(index, userInfo: IUserInfo) => (
            <UserDirectoryListItem
              key={userInfo.id + index}
              userInfo={userInfo}
              chatID={chatID}
              testId={testId}
            />
          )}
          components={{
            Footer: () => (
              <EmptyRecordView emptyMessage={t("endOfTheListMessage")} />
            ),
          }}
        />
      ) : (
        <EmptyRecordView />
      )}
    </UserDirectoryTabItemWrapper>
  );
};

export default UserDirectoryTabItem;
